"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.successfullyLoggedIn = void 0;

var _Schema = require("../../Schema");

/**
 * Action fired when a user logs into an existing account
 *
 * @example
 * ```
 * successfullyLoggedIn({
 *   authRedirect: "https://artsy.net/artist/andy-warhol",
 *   contextModule: ContextModule.popUpModal,
 *   copy: "Sign up to follow artists",
 *   intent: Intent.viewArtist,
 *   service: "email",
 *   triggerSeconds: 3,
 *   userId: "5bd8b675776bd6002c86526c"
 * })
 * ```
 */
const successfullyLoggedIn = ({
  authRedirect,
  contextModule,
  copy,
  intent,
  service,
  triggerSeconds,
  userId
}) => {
  return {
    action: _Schema.ActionType.successfullyLoggedIn,
    auth_redirect: authRedirect,
    context_module: contextModule,
    intent,
    modal_copy: copy,
    service,
    trigger: triggerSeconds && "timed" || "click",
    trigger_seconds: triggerSeconds,
    type: _Schema.AuthModalType.login,
    user_id: userId
  };
};

exports.successfullyLoggedIn = successfullyLoggedIn;